import { Button } from '@/shared/components';
import { cn } from '@/shared/lib/cn';

interface Props {
  /** Ohne Verbindung pausiert die Abfrage — kein Fehler, aber auch kein „nichts". */
  offline: boolean;
  /** Der Grund des Servers, wenn er einen genannt hat. */
  reason?: string | null;
  onRetry: () => void;
  className?: string;
}

/**
 * Was nicht geladen werden konnte, heißt so — nie „alle übernommen" und nie einfach nichts:
 * sonst sähe eine hängende Kanalbuchung genauso aus wie keine (FRONTEND_GUIDELINES §11). Ohne
 * Verbindung klärt es sich von selbst und bleibt ruhig; ein Fehler bekommt „Erneut laden".
 */
export function RevisionHoldsUnavailable({ offline, reason, onRetry, className }: Props) {
  if (offline) {
    return (
      <p
        role="status"
        className={cn('border-line bg-card text-ink-soft rounded-lg border p-4 text-sm', className)}
      >
        Keine Verbindung — ob Kanalbuchungen nicht übernommen wurden, zeigt sich, sobald sie zurück
        ist.
      </p>
    );
  }
  return (
    <div
      role="alert"
      className={cn('border-sealwax/40 bg-sealwax/10 rounded-lg border p-4', className)}
    >
      <p className="text-ink text-sm">
        Die nicht übernommenen Kanalbuchungen konnten nicht geladen werden
        {reason ? `: ${reason}` : '.'}
      </p>
      <Button type="button" variant="ghost" className="mt-2 min-h-11" onClick={onRetry}>
        Erneut laden
      </Button>
    </div>
  );
}
